import React, { useRef, useState, useEffect } from "react";
import { CustomDataTable, Popup, ToastNotification } from "../../shared";
import Outils from "./outils";
import { PurchaseInvoicesDetail } from "./purchase-invoices-details";
import { SuppliersService } from "../../../api";
import { useHistory } from "react-router";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { ActionClear } from "../commun/action-clear";

export const PurchaseInvoices = (props) => {
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState();
  const [dataDetails, setDataDetails] = useState(null);
  const [isDataDetails, setIsDataDetails] = useState(true);
  const [lazyParams, setLazyParams] = useState(Outils._getLazyParams());
  const [param, setParam] = useState(props.location.customNameData);
  const [filterParams, setFilterParams] = useState(
    Outils._getParamFilterInvoices()
  );
  const [clear, setClear] = useState(true);
  const toastRef = useRef();
  const dt = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (param) {
      _loadData();
    } else {
      history.push({
        pathname: "/supplier",
      });
    }
  }, [lazyParams, filterParams]);

  const onPage = (event) => {
    setLazyParams(event);
  };

  const onSort = (event) => {
    setLazyParams(event);
  };

  const _loadData = () => {
    setLoading(true);
    SuppliersService.getPurchaseInvoices(
      param,
      lazyParams.page,
      lazyParams.rows,
      filterParams
    ).then(
      (data) => {
        setData(
          Outils._mapInvoices(data.data.elements, _getActionInvoicesDetail)
        );
        setTotalRecords(data.data.totalElement);
        setLoading(false);
      },
      (error) => {
        toastRef?.current?.showToast({
          type: "error",
          title: "Error response",
          message: error,
        });
        setLoading(false);
      }
    );
  };
  const _getActionInvoicesDetail = (data, isDataDetails) => {
    setIsDataDetails(isDataDetails);
    setDataDetails(data);
  };

  const _getfilterContainer = () => {
    return (
      <div className="justify-content-center">
        <div className="row">
          <div className="col-sm filter-element">
            <span className="p-float-label">
              <InputText
                id="description"
                className="p-filter-tab-cs"
                name="description"
                value={filterParams.description}
                onChange={_handleChange}
              />
              <label htmlFor="description">Description</label>
            </span>
          </div>
          <div className="col filter-element">
            <span className="p-float-label">
              <InputText
                id="invoiceNum"
                className="p-filter-tab-cs"
                name="invoiceNum"
                value={filterParams.invoiceNum}
                onChange={_handleChange}
              />
              <label htmlFor="invoiceNum">Invoice number</label>
            </span>
          </div>

          <div className="col filter-element">
            <span className="p-float-label">
              <Calendar
                id="invoiceDate"
                className="p-filter-tab-cs"
                name="invoiceDate"
                monthNavigator
                yearNavigator
                type="Date"
                yearRange="2010:2200"
                value={filterParams.invoiceDate}
                onChange={_handleDateChange}
              />
              <label htmlFor="invoiceDate">Date</label>
            </span>
          </div>

          <div className="col filter-element">
            <span className="p-float-label">
              <InputText
                id="invoiceCurrencyCode"
                className="p-filter-tab-cs"
                name="invoiceCurrencyCode"
                value={filterParams.invoiceCurrencyCode}
                onChange={_handleChange}
              />
              <label htmlFor="invoiceCurrencyCode">Currency Code</label>
            </span>
          </div>

          <div className="col filter-element">
            <span className="p-float-label">
              <InputText
                id="invoiceStatus"
                className="p-filter-tab-cs"
                name="invoiceStatus"
                value={filterParams.invoiceStatus}
                onChange={_handleChange}
              />
              <label htmlFor="invoiceStatus">Status</label>
            </span>
          </div>
          <div className="filter-element-btn mt-1">
            <ActionClear onClick={_clearFilter} />
          </div>
        </div>
      </div>
    );
  };
  function _handleChange(e) {
    setFilterParams((prevState) => {
      return { ...prevState, [e.target.name]: e.target.value };
    });
  }

  function _handleDateChange(e) {
    setFilterParams((prevState) => {
      return {
        ...prevState,
        [e.target.name]: new Date(e.target.value).getTime(),
      };
    });
  }

  const _clearFilter = () => {
    setFilterParams(Outils._getParamFilterInvoices());
    setClear(true);
  };

  const _return = () => {
    history.push({
      pathname: "/purchaseOrders",
    });
  };
  return (
    <>
      {data && data[0]?.invoiceCurrencyCode === "DZD" && (
        <marquee>
          Chers Fournisseurs , la date de paiement reprise sur la plateforme est
          la date du lancement du paiement .Reste à considérer également la
          signature du paiement ainsi que le traitement de la banque .
        </marquee>
      )}

      <CustomDataTable
        title={"Purchase invoices, PO Number: " + param}
        icon="pi bi bi-person-lines-fill"
        data={data}
        lazy={true}
        totalRecords={totalRecords}
        loading={loading}
        ref={dt}
        onPage={onPage}
        onSort={onSort}
        first={lazyParams.first}
        page={lazyParams.page}
        rows={lazyParams.rows}
        clear={clear}
        return={_return}
        filterContainer={_getfilterContainer()}
        columns={Outils._getColumnsInvoices()}
        className="table-large"
      />
      <Popup
        title={"Invoice details"}
        visible={dataDetails}
        maximizable
        className="custom-dialog"
        content={
          <PurchaseInvoicesDetail
            isDataDetails={isDataDetails}
            data={dataDetails}
          />
        }
        onClose={() => {
          setDataDetails(null);
        }}
      ></Popup>
      <ToastNotification ref={toastRef} />
    </>
  );
};
